import wisdomDark from '@rhg/../public/_n/animations/wisdom_dark.json';

export default wisdomDark;
